<template>
  <v-container fluid grid-list-xl pa-0 style="position: relative">
    <!-- :searchData="searchData" -->
    <Toolbar
      @showProductList="show_product_list(true)"
      @moveUrls="show_move_urls(true)"
      @go_to_product_id="loadProduct"
    />
    <template>
      <ProductFilter />
    </template>
    <!-- <Table /> -->
    <!-- <ProductDetailsHeader /> -->
    <!-- <template v-if="show_selected_product_table">
      <ProductTable />
    </template> -->
    <router-view
      @loadProduct="loadProduct"
      @reloadProduct="
        loadProduct($store.state.productionModule.selected_product.id)
      "
    ></router-view>
    <v-dialog
      v-model="showProductTable"
      width="1500"
      class="product-list-modal"
    >

      <ProductListTable
        @closeProductList="show_product_list(false)"
        @select_a_product="loadProduct"
      />
    </v-dialog>
    <v-dialog
      v-model="showMoveUrls"
      width="1200"
      class="product-list-modal"
    >
      <v-container class="black-bg">
        <v-btn-toggle
          v-model="selected_component"
          mandatory
          label="Move to"
          tile
          color="deep-purple accent-1"
          group
          class=""
        >
          <v-btn
            v-for="(comp, c_idx) in the_components"
            :key="c_idx"
            :value="comp.value"
            class="mx-2"
          >{{ comp.name }}</v-btn>
        </v-btn-toggle>
      </v-container>
      <!-- <component :is="selected_component" @snackbar_show="create_snackbar" /> -->
      <!-- <component :is="selected_component"
        @snackbar="enable_snackbar"
        @closeMoveDialog="showMoveUrls = false;loadProduct($store.state.productionModule.selected_product.id)"
      /> -->
      <MoveUrlsToNew
        v-if="selected_component === 'MoveUrlsToNew'"
        :urls="this.$store.state.productionModule.selected_urls_of_product"
        type="Move"
        @created_new_product="$emit('reloadProduct')"
        @reload_product="loadProduct(selected_product_id)"
        @close_dialog="showMoveUrls = false"
      />
      <MoveUrls
        v-else-if="selected_component === 'MoveUrls'"
        @snackbar="enable_snackbar"
        @closeMoveDialog="showMoveUrls = false;loadProduct($store.state.productionModule.selected_product.id)"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      text
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="variationSuccessSnackbar" color="success"><div class="text-center"> Variation updated successfully! </div></v-snackbar>
    <v-snackbar v-model="variationErrorSnackbar" color="error"><div class="text-center"> Error on variation update! </div></v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable */
import ProductFilter from "../components/production/N_ProductFilter.vue";
import Table from "@/components/production/N_Table";
import Toolbar from "../components/production/N_Toolbar.vue";
import ProductListTable from "@/components/production/N_ProductListTable.vue";
import ProductTable from "@/components/production/N_ProductTable";
import MoveUrls from "@/components/production/N_MoveUrls.vue";
import MoveUrlsToNew from "@/components/production/N_MoveUrlsToNew.vue";
import { productionBus } from "@/helpers/buses";

export default {
  name: "Production-Page",
  components: {
    ProductFilter,
    Toolbar,
    ProductListTable,
    // ProductDetailsHeader,
    ProductTable,
    Table,
    MoveUrls,
    MoveUrlsToNew
  },
  data: () => ({
    showProductTable: false,
    showMoveUrls: false,
    snackbar: {
      show: false,
      timeout: 4000,
      text: "",
      color: "primary"
    },
    selected_component: undefined,
    the_components: [
      {
        name: 'New Product',
        value: 'MoveUrlsToNew',
      },
      {
        name: 'Existing Product',
        value: 'MoveUrls',
      },
    ]
  }),

  methods: {
    enable_snackbar(text) {
      this.snackbar.show = true;
      this.snackbar.text = text;
    },
    go_to_product(id) {
      console.log("go to product", id);
      // const data = { value: id , key: 'id' };
      // this.$store.commit('productionModule/SET_SELECTED_PRODUCT', data );
    },
    show_move_urls(show) {
      this.showMoveUrls = show;
    },
    show_product_list(show) {
      this.showProductTable = show;
    },
    get_Variations() {
      if (!this.variations.color && !this.variations.size) {
        this.$store
          .dispatch("productionModule/general_api", { task: "load_variations" })
          .then((res) => {
            const variations = {
              key: "variations",
              value: res.data.variations,
            };
            this.$store.commit(
              "productionModule/SET_PRODUCTION_STATE",
              variations
            );
            const translations = {
              key: "translations",
              value: res.data.translations,
            };
            this.$store.commit(
              "productionModule/SET_PRODUCTION_STATE",
              translations
            );
          })
          .catch((err) => {
            console.log(
              "error on load variations from production.vue #8567: ",
              err
            );
          });
      }
    },
    get_clients() {
      if (this.clients.length < 2) {
        const payload = { task: "load_clients" };
        this.$store
          .dispatch("productionModule/general_api", payload)
          .then((res) => {
            console.log('clients', JSON.parse(JSON.stringify(res.data.clients)))
            // const temp_clients = res.data.clients.map(((x) => ({ [id]: x.value, [name]: x.text})));
            // console.log('temp_clients', temp_clients);
            const active_clients = res.data.clients.filter(a => a.active);
            const actives = { value: active_clients, key: 'clients_list'}
            this.$store.commit("productionModule/SET_PRODUCTION_STATE", actives);
            const inactive_clients = res.data.clients.filter(a => !a.active);
            const inactives = { value: inactive_clients, key: 'inactive_clients'}
            this.$store.commit("productionModule/SET_PRODUCTION_STATE", inactives);
            this.$store.commit("productionModule/SET_PRODUCTION_STATE", { value: res.data.lists, key: 'lists' });
            this.$store.commit("productionModule/SET_PRODUCTION_STATE", { value: res.data.sync_status, key: 'sync_status' });
          });
      }
    },

    loadProduct(product_id) {
      this.$store.commit("productionModule/RESET_PRODUCTION");
      // this.$store.commit("productionModule/RESET_VALIDS_AND_CONFLICTS");
      this.$store.commit("productionModule/RESET_SPECS_OF_SELECTED_ITEM");
      const data = { value: product_id, key: "id" };
      this.$store.commit("productionModule/SET_SELECTED_PRODUCT", data);
      this.loading = true;
      const payload = {
        task: "getProducts",
        payload: { product_id: [product_id] },
      };
      if(this.filter.product_status === 'pending')
          payload.payload.list_id = this.filter.list
      this.$store
        .dispatch("productionModule/general_api", payload)
        .then((res) => {
          this.loading = false;
          console.log('res.data', res.data);
          if( res.data.status !== 'Success' ){
            this.snackbar.color = 'red';
            this.snackbar.text = 'Error on load products';
            this.snackbar.show = true;
            return false;
          }
          const data = {
            key: "specs",
            value: res.data.specs,
          };
          this.$store.commit("productionModule/SET_SELECTED_PRODUCT", data);
          this.$store.commit("productionModule/SET_SELECTED_PRODUCT_STATUS", res.data.productStatus)
        });
      this.$emit("closeProductList");
      // this.$router.push({ name: "product-table" });
    },
  },
  computed: {
    filter() {
      return this.$store.state.productionModule.product_filter
    },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set(value) {
        const data = { value, key: "loading" };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      }
    },
    clients() {
      return this.$store.state.productionModule.clients_list;
    },
    variations() {
      return this.$store.state.productionModule.variations;
    },
    selected_product_id() {
      return this.$store.state.productionModule.selected_product.id;
    },
    show_selected_product_table() {
      // return this.$store.getters.show_selected_product_test;
      return this.$store.state.productionModule.loaded_products
        .map((product) => product.product_id)
        .includes(this.$store.state.productionModule.selected_product.id);
    },
    searchData() {
      return "test searchData";
    },
    productsCount() {
      return "test productsCount";
    },
    dataOfClients() {
      return "test dataOfClients";
    },
    variationSuccessSnackbar: {
       get() {
        return this.$store.state.productionModule.variationSuccessSnackbar;
      },
      set(value) {
        this.$store.commit("productionModule/SET_variationSuccessSnackbar", value);
      }
    },
    variationErrorSnackbar: {
       get() {
        return this.$store.state.productionModule.variationErrorSnackbar;
      },
      set(value) {
        this.$store.commit("productionModule/SET_variationErrorSnackbar", value);
      }
    },
  },
  mounted() {
    // reset the store
    this.$store.commit("productionModule/RESET_PRODUCTION");
  },
  created() {
    this.get_clients();
    this.get_Variations();
    productionBus.$on("open_snackbar", ({text, color}) => {
      console.log('snackbar open', text );
      this.snackbar.text = text;
      ( !!color ) && ( this.snackbar.color = color )
      this.snackbar.show = true;
      // this.snackbar.color = color;
    });
    productionBus.$on("loadProduct", id => { this.loadProduct(id) });
  },
};
</script>

<style scoped>
/* .add-new-product {
  position: absolute;
  right: 0%;
} */
.black-bg {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/Production.vue